import { render, staticRenderFns } from "./FormRadio.vue?vue&type=template&id=23fddb46&scoped=true&"
import script from "./FormRadio.ts?vue&type=script&lang=ts&"
export * from "./FormRadio.ts?vue&type=script&lang=ts&"
import style0 from "./Formradio.scss?vue&type=style&index=0&id=23fddb46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fddb46",
  null
  
)

export default component.exports